import publicpb from '../../base/public.pb';
import profileSetpb from './set.pb';
import PbAjax from '../pbajax';

const pbajax = new PbAjax();

class ProfileSet {

    constructor(data = {}) {
        this.promise = this.set(data);
    }

    set(data) {
        let defer = $.Deferred()
        let businessData = new profileSetpb.Profile.Set.Request(data);
        let ua = window.navigator.userAgent;

        let requestData = {
            service: 'service',
            api: '/profile/set',
            header: {
                userToken: UpSDK.getUserToken(),
                UserAgent: ua
            }
        }

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == 1) {
                    defer.resolve(true);
                } else {
                    defer.reject();
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            });
        
        return defer.promise();
    }
}
export default ProfileSet;


// WEBPACK FOOTER //
// ./js/component/openjs/deps/profile/set.js